import { EHttpMethod } from '../common/enums/fetch.enum';

export default class ApiRoutes {
  public method: EHttpMethod;
  public url: string;

  // Partner Dashboard
  public static getNews = new ApiRoutes(`/wp-json/ringana/v1/newsNewRoute`, EHttpMethod.GET);

  // Customers
  public static getAddresses = new ApiRoutes(`/customers/addresses`, EHttpMethod.GET);
  public static getAddressById = new ApiRoutes(`/customers/addresses/:addressId`, EHttpMethod.GET);
  public static getLoginCheck = new ApiRoutes(`/customers/login/check`, EHttpMethod.GET);
  public static getCalendarData = new ApiRoutes(`/customers/calendar`, EHttpMethod.GET);
  public static postChallengeRegistrationEmail = new ApiRoutes(`/customers/fse`, EHttpMethod.POST);
  public static postNewsletterConfirm = new ApiRoutes(`/customers/newsletter`, EHttpMethod.POST);
  public static patchNewAddress = new ApiRoutes(`/customers/address`, EHttpMethod.PATCH);
  public static removeNewAddress = new ApiRoutes(`/customers/address/:customerId/:addressId`, EHttpMethod.DELETE);
  public static updateNewsletter = new ApiRoutes(`/customers/newsletter`, EHttpMethod.PATCH);
  public static unsubscribeNewsletter = new ApiRoutes(`/customers/newsletter/unsubscribe`, EHttpMethod.POST);
  public static verifyTaxNumber = new ApiRoutes(`/customers/tax-numbers`, EHttpMethod.POST);
  public static customerSession = new ApiRoutes(`/customers/session`, EHttpMethod.GET);

  // Carts
  public static getCartCount = new ApiRoutes(`/carts/count`, EHttpMethod.GET);
  public static deleteCart = new ApiRoutes(`/carts`, EHttpMethod.DELETE);
  public static deleteCoupon = new ApiRoutes(`/carts/coupon`, EHttpMethod.GET);
  public static deleteItemFromCart = new ApiRoutes(`/carts/item`, EHttpMethod.DELETE);
  public static getCart = new ApiRoutes(`/carts`, EHttpMethod.GET);
  public static postCartCreate = new ApiRoutes(`/carts/create`, EHttpMethod.POST);
  public static postItemToCart = new ApiRoutes(`/carts/item`, EHttpMethod.POST);
  public static updateCartItem = new ApiRoutes(`/carts/item`, EHttpMethod.PUT);
  public static redeemCoupon = new ApiRoutes(`/carts/coupon`, EHttpMethod.POST);
  public static removeCoupon = new ApiRoutes(`/carts/coupon`, EHttpMethod.DELETE);

  // Partners
  public static getPartnerApplication = new ApiRoutes(`/partners/application/:addressId`, EHttpMethod.GET);
  public static getPartnerInfo = new ApiRoutes(`/partnerinfo/:name`, EHttpMethod.GET);
  public static postPartnerSearch = new ApiRoutes(`/partners/search`, EHttpMethod.POST);
  public static postPartnerApplication = new ApiRoutes(`/partners/application`, EHttpMethod.POST);
  public static postPartnerApplicationPreCheck = new ApiRoutes(`/partners/application/check`, EHttpMethod.POST);
  public static postPartnerImage = new ApiRoutes(`/partners/image`, EHttpMethod.POST);
  public static getIncentives = new ApiRoutes(`/partners/incentives/`, EHttpMethod.GET);
  public static getIncentiveRanking = new ApiRoutes(`/partners/incentives/:id/ranking`, EHttpMethod.GET);
  public static getIncentiveData = new ApiRoutes(`/partners/incentives/:id/data`, EHttpMethod.GET);
  public static getSearchResults = new ApiRoutes(`/partners/incentives/search/:idincentive/:search`, EHttpMethod.POST);
  public static votePartner = new ApiRoutes(`/partners/incentives/vote/:idincentive/:cn`, EHttpMethod.POST);
  public static postItalianPartnerPicture = new ApiRoutes(`/partners/italian/picture`, EHttpMethod.POST);
  public static updateItalianPartnerPicture = new ApiRoutes(`/partners/italian/picture`, EHttpMethod.PATCH);
  public static getItalianPartnerPicture = new ApiRoutes(`/partners/italian/picture`, EHttpMethod.GET);

  // Products
  public static getPartnerApplicationProducts = new ApiRoutes(`/products/partner-applications`, EHttpMethod.GET);
  public static getProducts = new ApiRoutes(`/products`, EHttpMethod.GET);
  public static getProductByMatchcode = new ApiRoutes(`/products/:matchcode`, EHttpMethod.GET);
  public static getReducedProducts = new ApiRoutes(`/products/reduced`, EHttpMethod.GET);

  // Configs
  public static getSalutations = new ApiRoutes(`/configs/salutations`, EHttpMethod.GET);
  public static getCountries = new ApiRoutes(`/configs/countries`, EHttpMethod.GET);
  public static getAllCountries = new ApiRoutes(`/configs/countries/all`, EHttpMethod.GET);
  public static getCurrencies = new ApiRoutes(`/configs/currencies`, EHttpMethod.GET);

  // Statistics
  public static getDashboardData = new ApiRoutes(`/statistics/partner-dashboard`, EHttpMethod.GET);

  // Search
  public static getSearchData = new ApiRoutes(`/search/post-types/:role`, EHttpMethod.GET);

  // Teams
  public static postBarometerData = new ApiRoutes(`/teams/target-levels/data`, EHttpMethod.POST);

  // Document Signing
  public static createDocuSignRecipientView = new ApiRoutes(`/document-signing/recipient-view`, EHttpMethod.POST);

  // Images
  public static postImage = new ApiRoutes(`/images`, EHttpMethod.POST);
  public static deleteImage = new ApiRoutes(`/images/:key`, EHttpMethod.DELETE)

  constructor(url: string, method: EHttpMethod) {
    this.method = method;
    this.url = url;
  }
}
